export default {
  install(Vue){
    Vue.prototype.$flash = new Vue()
  }
};